import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Injector, input, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BooleanInputType, toBooleanProperty } from '@utils/boolean';
import { WizardItemEntity } from '@wizard/wizard-panel/models';
import { WizardPanelController } from '@wizard/wizard-panel/services';
import { WizardPanelListItemComponent } from '../wizard-panel-list-item';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mir-wizard-panel-list',
  templateUrl: './wizard-panel-list.component.html',
  styleUrls: ['./wizard-panel-list.component.scss'],
  imports: [
    CommonModule,
    WizardPanelListItemComponent
  ]
})
export class WizardPanelListComponent {

  /** @Input */
  readonly editable = input(true, { transform: (value: BooleanInputType) => toBooleanProperty(value) });

  /** @Inject */
  readonly #wizardPanelController = inject(WizardPanelController);

  readonly dataList: Signal<WizardItemEntity[]>;

  constructor() {
    const injector = inject(Injector);

    this.dataList = toSignal(
      this.#wizardPanelController.dataList$,
      { initialValue: null, injector }
    );
  }
}
